webpackJsonp([51],{

/***/ 1049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_login_js__ = __webpack_require__(1157);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96518268_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1228);
var normalizeComponent = __webpack_require__(193)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96518268_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(511);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      branch: '',
      date_time_start: new Date()
    };
  },

  methods: {
    sigin: function sigin() {
      var _this = this;

      this.$store.commit('Loading');
      var body = {
        'username': this.username,
        'password': this.password
      };
      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].isLogin(this.CompanyConfig.base_api, body, function (result) {
        if (result.response === 'success') {
          sessionStorage.token = result.data.token;
          _this.$store.state.token = result.data.token;
          sessionStorage.Url = _this.CompanyConfig.base_api;
          _this.getProfile();
        } else {
          _this.alert_msg('warning', 'เข้าสู่ระบบ', result.message);
          _this.$store.commit('Loading');
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    getProfile: function getProfile() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].userDetail(sessionStorage.Url, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, {}, function (result) {
        if (result.response === 'success') {
          sessionStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          _this2.$store.state.user = result.data;
          _this2.getRoleMenu(_this2.$store.state.user.role_id);
          setTimeout(function () {
            _this2.$store.commit('Loading');
            if (_this2.$store.state.user.role_id === 4) {
              _this2.$router.push('/calendar');
            } else {
              _this2.$router.push('/');
            }
          }, 1000);
          _this2.alert_msg('success', 'เข้าสู่ระบบ', 'ยินดีตอนรับคุณ ' + _this2.username + ' เข้าสู่ระบบ');
        } else {
          _this2.alert_msg('warning', 'เข้าสู่ระบบ', result.message);
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this2.$store.commit('Loading');
      });
    },
    getRoleMenu: function getRoleMenu(val) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */].GetMisMenuRole(sessionStorage.Url, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, { role_id: val }, function (result) {
        if (result.response === 'success') {
          sessionStorage.menu_page = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
        } else {
          _this3.alert_msg('warning', 'เข้าสู่ระบบ', result.message);
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    }
  },
  mounted: function mounted() {
    // this.branch = this.CompanyConfig.branch[0]
  }
});

/***/ }),

/***/ 1228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hold-transition login-page"},[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body login-card-body text-center"},[_c('img',{staticClass:"mb-3",attrs:{"src":_vm.CompanyConfig.logo_path || '../../static/logo.jpg',"width":"150"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.sigin($event)}}},[_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Username","required":"","autocomplete":"new-username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","required":"","autocomplete":"new-password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"help-block text-center"},[_vm._v("\n            เวลา "+_vm._s(_vm.dateFormatAndTime(_vm.date_time_start))+" น.\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fas fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fas fa-lock"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit"}},[_vm._v("\n                LOGIN\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-3"},[_c('a',{attrs:{"href":"/forgot"}},[_vm._v("ลืมรหัสผ่าน")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.78942b80281d29fb8483.js